import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=59879dbc&scoped=true&"
import script from "./StyleGuide.vue?vue&type=script&lang=js&"
export * from "./StyleGuide.vue?vue&type=script&lang=js&"
import style0 from "./StyleGuide.vue?vue&type=style&index=0&id=59879dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59879dbc",
  null
  
)

export default component.exports